import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './important-user-details.reducer';

export const ImportantUserDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const importantUserDetailsEntity = useAppSelector(state => state.importantUserDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="importantUserDetailsDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.importantUserDetails.detail.title">ImportantUserDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.id}</dd>
          <dt>
            <span id="physicGoal">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.physicGoal">Physic Goal</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.physicGoal}</dd>
          <dt>
            <span id="height">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.height">Height</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.height}</dd>
          <dt>
            <span id="weight">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.weight">Weight</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.weight}</dd>
          <dt>
            <span id="supplementPrference">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.supplementPrference">Supplement Prference</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.supplementPrference ? 'true' : 'false'}</dd>
          <dt>
            <span id="dietPreferrence">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.dietPreferrence">Diet Preferrence</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.dietPreferrence}</dd>
          <dt>
            <span id="preferredNonVegDays">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.preferredNonVegDays">Preferred Non Veg Days</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.preferredNonVegDays}</dd>
          <dt>
            <span id="wakeUpTime">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.wakeUpTime">Wake Up Time</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.wakeUpTime}</dd>
          <dt>
            <span id="bedTime">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.bedTime">Bed Time</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.bedTime}</dd>
          <dt>
            <span id="breakfastTime">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.breakfastTime">Breakfast Time</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.breakfastTime}</dd>
          <dt>
            <span id="lunchTime">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.lunchTime">Lunch Time</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.lunchTime}</dd>
          <dt>
            <span id="dinnerTime">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.dinnerTime">Dinner Time</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.dinnerTime}</dd>
          <dt>
            <span id="workoutTime">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.workoutTime">Workout Time</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.workoutTime}</dd>
          <dt>
            <span id="workTime">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.workTime">Work Time</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.workTime}</dd>
          <dt>
            <span id="medicalHistory">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.medicalHistory">Medical History</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.medicalHistory}</dd>
          <dt>
            <span id="allergy">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.allergy">Allergy</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.allergy}</dd>
          <dt>
            <span id="suggestions">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.suggestions">Suggestions</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.suggestions}</dd>
          <dt>
            <span id="name">
              {/* <Translate contentKey="fitengineerBackendV2App.importantUserDetails.name">Name</Translate> */}
              Address
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.address}</dd>
          <dt>
            <span id="dislikedFoods">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.dislikedFoods">Disliked Foods</Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.dislikedFoods}</dd>
          <dt>
            <span id="easilyAvilableFoodSources">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.easilyAvilableFoodSources">
                Easily Avilable Food Sources
              </Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.easilyAvilableFoodSources}</dd>
          <dt>
            <span id="barbellChestPress">Barbell Chest Press</span>
          </dt>
          <dd>{importantUserDetailsEntity.barbellChestPress}</dd>

          <dt>
            <span id="barbellShoulderPress">Barbell Shoulder Press</span>
          </dt>
          <dd>{importantUserDetailsEntity.barbellShoulderPress}</dd>

          <dt>
            <span id="deadlift">Deadlift</span>
          </dt>
          <dd>{importantUserDetailsEntity.deadlift}</dd>

          <dt>
            <span id="squats">Squats</span>
          </dt>
          <dd>{importantUserDetailsEntity.squats}</dd>

          <dt>
            <span id="barbellBicepsCurls">Barbell Biceps Curls</span>
          </dt>
          <dd>{importantUserDetailsEntity.barbellBicepsCurls}</dd>

          <dt>
            <span id="hamstringsCurls">Hamstrings Curls</span>
          </dt>
          <dd>{importantUserDetailsEntity.hamstringsCurls}</dd>

          <dt>
            <span id="tricepCablePushDown">Tricep Cable Push Down</span>
          </dt>
          <dd>{importantUserDetailsEntity.tricepCablePushDown}</dd>

          <dt>
            <span id="latpulldown">Lat Pulldown</span>
          </dt>
          <dd>{importantUserDetailsEntity.latpulldown}</dd>
          <dt>
            <span id="confirmationDigitalSignature">
              <Translate contentKey="fitengineerBackendV2App.importantUserDetails.confirmationDigitalSignature">
                Confirmation Digital Signature
              </Translate>
            </span>
          </dt>
          <dd>{importantUserDetailsEntity.confirmationDigitalSignature ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.importantUserDetails.user">User</Translate>
          </dt>
          <dd>
            <Button tag={Link} to={`/admin/user-management/${importantUserDetailsEntity?.user?.login}`} color="link" size="md">
              {importantUserDetailsEntity.user ? importantUserDetailsEntity.user.login : ''}
            </Button>
            {/* {importantUserDetailsEntity.user ? importantUserDetailsEntity.user.login : ''} */}
          </dd>
        </dl>
        <Button tag={Link} to="/important-user-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/important-user-details/${importantUserDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ImportantUserDetailsDetail;
